import styled from 'styled-components';
import { motion } from 'framer-motion';
import breakpoint, { getZindexByType } from '~/utils/style-utils.ts';
import { sidebarTop } from '~/utils/layout-utils.js';
import useUIContext from '~/ui/use-ui-context';
import { forwardRef } from 'react';

const OverlayWrapperStyled = styled(motion.div)`
	background-color: var(--sidebar-bg, rgba(var(--base-11), 1));
	overflow-x: hidden;
	position: fixed;
	left: 0;
	top: ${({ uiContext }) => (uiContext.hasStaticHeader ? `var(--regulationHeight)` : '0')};
	width: 100%;
	max-width: 100vw;
	height: ${({ uiContext }) => (uiContext.hasStaticHeader ? `calc(100% - var(--regulationHeight))` : '100%')};
	z-index: ${getZindexByType('overlay')};
	-webkit-overflow-scrolling: touch;
	${breakpoint.lg`
		height: ${`calc(100% - var(--headerHeight) + var(--subHeaderHeight))`};
		left: 0;
		top: ${({ uiContext }) => sidebarTop(uiContext)};
		width: var(--detailWidth);
		padding: 0 12px;
	`};
	.menu,
	.deposit {
		height: 100%;
		min-height: 100%;
	}
	.deposit {
		transform: none;
	}
	.menu.global-menu {
		transform: none;
		height: auto;
	}
	.menu .menu__content-wrapper {
		padding: 0;
		height: auto;
	}
`;

const OverlayWrapper = forwardRef((props, ref) => {
	const uiContext = useUIContext();
	return <OverlayWrapperStyled {...props} uiContext={uiContext} ref={ref} />;
});

export default OverlayWrapper;
